// extracted by mini-css-extract-plugin
export default {"container":"StripeReturnPage_container__T6GZV","icon":"StripeReturnPage_icon__29PhA","formButton":"StripeReturnPage_formButton__HeUtG"};